import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
//import 'semantic-ui-css/semantic.min.css';
import { ajaxPost } from '../ajax';
import {NotificationPopupControl} from './MasterPageControls'

// Cache for notification preview to avoid repeated database calls
let notificationCache = {
    data: [],
    lastFetch: null,
    cacheTimeout: 60000 // Cache for 1 minute
};

// Export function to clear cache (useful on logout)
export const clearNotificationCache = () => {
    notificationCache.data = [];
    notificationCache.lastFetch = null;
};

class NotificationPreview extends Component {
    state =
        {
            notifications: []
        }

    componentWillMount = () => {
        // Check if we have cached data
        const now = new Date().getTime();
        const isCacheValid = notificationCache.lastFetch &&
                           (now - notificationCache.lastFetch) < notificationCache.cacheTimeout;

        if (isCacheValid && notificationCache.data.length > 0) {
            // Use cached data
            this.setState({ notifications: notificationCache.data });
        } else {
            // Fetch from server
            this.updateNotificationList();
        }

        // Setup SignalR listener
        this.setupSignalRListener();
    }

    componentWillUnmount = () => {
        // Clean up SignalR listener
        if (this.signalRCleanup) {
            this.signalRCleanup();
        }
    }

    setupSignalRListener = () => {
        // Register notification handler for real-time updates
        if (global.SignalRConnection) {
            const sessionId = global.sessionId;
            const eventName = `userId:${sessionId}`;

            const handleNotification = (dataStr) => {
                try {
                    const data = JSON.parse(dataStr);

                    // Handle new notification
                    if (data.Type === "NewNotification") {
                        // Prepend new notification to the list (keep only top 5)
                        const newNotification = {
                            data: data.Data,
                            enabled: true
                        };

                        this.setState(prevState => {
                            const updatedNotifications = [newNotification, ...prevState.notifications].slice(0, 5);
                            // Update cache
                            notificationCache.data = updatedNotifications;
                            notificationCache.lastFetch = new Date().getTime();
                            return { notifications: updatedNotifications };
                        });
                    } else if (data.Type === "NotificationRead") {
                        // Update notification in the list to mark as read
                        this.setState(prevState => {
                            const updatedNotifications = prevState.notifications.map(notif => {
                                if (notif.data._id === data.NotificationId) {
                                    return {
                                        ...notif,
                                        data: { ...notif.data, ActionTaken: "READ" }
                                    };
                                }
                                return notif;
                            });
                            // Update cache
                            notificationCache.data = updatedNotifications;
                            return { notifications: updatedNotifications };
                        });
                    } else if (data.Type === "AllNotificationsRead") {
                        // Mark all notifications as read
                        this.setState(prevState => {
                            const updatedNotifications = prevState.notifications.map(notif => ({
                                ...notif,
                                data: { ...notif.data, ActionTaken: "READ" }
                            }));
                            // Update cache
                            notificationCache.data = updatedNotifications;
                            return { notifications: updatedNotifications };
                        });
                    }
                } catch (error) {
                    console.error("Error processing notification:", error);
                }
            };

            global.SignalRConnection.on(eventName, handleNotification);

            // Store cleanup function
            this.signalRCleanup = () => {
                global.SignalRConnection.off(eventName, handleNotification);
            };
        }
    }

    updateNotificationList = () => {
        var searchParameter = {
            data: {
                StartIndex: 0,
                MaxData: 5,
            },
            url: "api/Notification/list",
            onError: (error) => { },
            onSuccess: (data, sender) => {
                var list = data.map((x) => {
                    return {
                        data: x,
                        enabled: true,
                    };
                });
                this.setState({ notifications: list });

                // Update cache
                notificationCache.data = list;
                notificationCache.lastFetch = new Date().getTime();
            },
            finally: () => { }
        };
        ajaxPost(searchParameter);
    };

    handleMarkReadAll = () => {
        ajaxPost({
            url: "api/notification/markAsReadAll",
            data: "",
            onSuccess: (data) => { },
            finally: () => { },
        });
    };

    render() {
        return (
            <div>
                <Button
                    style={{
                        border: "none",
                        backgroundColor: "transparent",
                    }}
                    size="mini"
                    floated="right"
                    icon="envelope open outline"
                    content="Mark all as read"
                    onClick={this.handleMarkReadAll}
                />
                <br /> <br />
                <NotificationPopupControl
                    notifications={this.state.notifications}
                    notificationItemClick={this.props.notificationItemClick}
                    parent={this.props.parent}
                />
                <div
                    onClick={this.props.handleViewAllNotif}
                    style={{ padding: "10px", cursor: "pointer"}}
                >
                    View All Notifications
                </div>
            </div>
        )
    }
}

export default NotificationPreview;